import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import Select from "react-select";
import { Table } from "react-bootstrap";
import { API_URL } from "../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import moment from "moment";
import CustomDatePicker from "./component/Custom-Datepicker";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import debounce from "lodash/debounce";
import Pagination from "../../../components/Pagination";
import InvoiceRow from "./InvoiceRow";

const customStyle = {
  formLabel: {
    fontSize: "14px",
    fontWeight: "600",
  },
  formControl: {
    width: "105px",
    borderRadius: "6px",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    color: "#212529",
    border: "1px solid #ced4da",
  },
  formCheckInput: {
    margin: "0",
  },
};

const customIndicator = {
  display: "inline-block",
  width: "20px",
  height: "20px",
  borderRadius: "50%",
  marginBottom: "0px",
  verticalAlign: "middle",
  marginLeft: "10px",
  marginRight: "3px",
  boxShadow: "0 2px 9px 0 rgba(0, 0, 0, 0.18), 0 2px 7px 0 rgba(0, 0, 0, 0.15)",
  border: "solid 2px #fff",
};

const InvoiceList = () => {
  const intialInvoiceFilter = {
    clientID: null,
    employeeID: null,
    projectID: null,
  };
  const [filterData, setFilterData] = useState(intialInvoiceFilter);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [projectallocationOption, setProjectAllocationOption] = useState([]);
  const [accordionData, setAccordionData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(250);
  const [selectedItems, setSelectedItems] = useState([]);
  const [apiStatus, setApiStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [submitButton, setSubmitButton] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Invoice List ( Consulting & Content )"));
    fetchIndexApi();
    fetchApiData(filterData);
  }, [dispatch]);

  const fetchIndexApi = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/list/invoice-list/consulting-and-content-getData`
      );

      if (response?.status === 200) {
        const cleanedData = response?.data?.data;

        setClientOptions(
          cleanedData?.clients?.map((ele) => ({
            value: ele?.value,
            label: ele?.text,
          })) || []
        );

        setProjectOptions(
          cleanedData?.projects?.map((ele) => ({
            value: ele?.value,
            label: ele?.text,
          })) || []
        );

        setEmployeeOptions(
          cleanedData?.employee?.map((ele) => ({
            value: ele?.value,
            label: ele?.text,
          })) || []
        );

        setProjectAllocationOption(
          cleanedData?.projectallocationtype?.map((ele) => ({
            value: ele?.value,
            label: ele?.text,
          })) || []
        );
      }
    } catch (error) {
      console.error("Fetching Error ", error);
      toast.error("Failed to load initial data");
    }
  };

  const fetchApiData = async (filterParams = {}) => {
    setIsLoading(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/list/invoice-list/consulting-and-content?P_ClientID=&P_ProjectID=&P_EmployeeID=`
      );

      if (response?.status === 200) {
        setApiStatus(response?.status);
        const dataWithIndex = response?.data?.data?.map((item, index) => ({
          ...item,
          index,
        }));

        setAccordionData(dataWithIndex?.map(o => ({
          ...o, AdjustmentAmount: Number(o.AdjustmentAmount).toFixed(2), TaxPercent: Number(o.TaxPercent).toFixed(0), ExchangeRate: Number(o.ExchangeRate).toFixed(2), OriginalBasicAmount: Number(o.BasicAmount)
        })) || []);
      }
    } catch (error) {
      console.error("Error Fetching the Api ", error);
      toast.error("Failed to fetch invoice data");
      setApiStatus(null);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchApiGetData = async (filterParams = {}) => {
    setIsLoading(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}projectmanagement/list/invoice-list/consulting-and-content?P_ClientID=${filterParams?.clientID || ""
        }&P_ProjectID=${filterParams?.projectID || ""}&P_EmployeeID=${filterParams?.employeeID || ""
        }`
      );

      if (response?.status === 200) {
        setApiStatus(response?.status);
        const dataWithIndex = response?.data?.data?.map((item, index) => ({
          ...item,
          index,
        }));
        setAccordionData(dataWithIndex || []);
      }
    } catch (error) {
      console.error("Error Fetching the Api ", error);
      toast.error("Failed to fetch invoice data");
      setApiStatus(null);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterSelect = useCallback((selectedOptions, name) => {
    setFilterData((prev) => ({
      ...prev,
      [name]: selectedOptions?.value || null,
    }));
  }, []);

  // pagination
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Compute the current page's data
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, accordionData.length);
  const paginatedData = accordionData.slice(startIndex, endIndex);

  const groupedData = useMemo(() => {
    if (!accordionData.length) return {};

    return paginatedData.reduce((acc, item) => {
      const { tmpClientName, tmpProjectName } = item;
      acc[tmpClientName] = acc[tmpClientName] || {};
      acc[tmpClientName][tmpProjectName] = acc[tmpClientName][tmpProjectName] || [];
      acc[tmpClientName][tmpProjectName].push(item);
      return acc;
    }, {});
  }, [paginatedData]);

  const handleFilter = () => {
    fetchApiGetData(filterData);
  }

  const handleReset = () => {
    setFilterData(intialInvoiceFilter);
    // setAccordionData([]);
    setSelectedItems([]);
    fetchApiData(filterData);
    setApiStatus(null);
  }

  const handleFieldChange = useCallback((itemIndex, fieldName, value) => {
    setAccordionData((prev) => {
      const item = prev[itemIndex];
      const updatedItem = { ...item, [fieldName]: value };

      // Calculate amounts only when relevant fields change
      if (["TaxPercent", "AdjustmentAmount", "ExchangeRate", "InvoicedDays"].includes(fieldName)) {
        // Recompute BasicAmount when InvoicedDays changes
        if (fieldName === "InvoicedDays") {
          const originalBasicAmount = parseFloat(updatedItem.OriginalBasicAmount) || 0;
          const workingDays = parseFloat(updatedItem.WorkingDays) || 0;
          const invoicedDays = parseFloat(value);
          updatedItem.BasicAmount = (workingDays > 0 && invoicedDays > 0)
            ? ((originalBasicAmount / workingDays) * invoicedDays).toFixed(2)
            : originalBasicAmount.toFixed(2);
        }

        const basicAmount = parseFloat(updatedItem.BasicAmount) || 0;
        const taxPercent = parseFloat(updatedItem.TaxPercent) || 0;
        const adjustmentAmount = parseFloat(updatedItem.AdjustmentAmount) || 0;
        const exchangeRate = parseFloat(updatedItem.ExchangeRate) || 1;

        const invoiceAmount = basicAmount + adjustmentAmount;
        const invoiceWithTax = invoiceAmount + (invoiceAmount * taxPercent) / 100;
        const invoiceCalculatedAmount = (invoiceWithTax * exchangeRate).toFixed(2);

        updatedItem.InvoiceAmount = invoiceAmount;
        updatedItem.InvoiceCalculatedAmount = invoiceCalculatedAmount;
      }

      return [
        ...prev.slice(0, itemIndex),
        updatedItem,
        ...prev.slice(itemIndex + 1),
      ];
    });
  }, []);

  const handleDateChange = useCallback((dateValue, itemIndex, fieldName) => {
    setAccordionData((prev) => {
      const item = prev[itemIndex];
      const updatedItem = { ...item, [fieldName]: dateValue.target.value };

      return [
        ...prev.slice(0, itemIndex),
        updatedItem,
        ...prev.slice(itemIndex + 1),
      ];
    });
  }, []);

  const handleCheckBoxChange = useCallback(
    (e, itemIndex, data) => {
      const isSelected = selectedItems.some((item) => item.index === itemIndex);

      if (isSelected) {
        setSelectedItems((prev) =>
          prev.filter((item) => item.index !== itemIndex)
        );
      } else {
        setSelectedItems((prev) => [...prev, { ...data, index: itemIndex }]);
      }
    },
    [selectedItems]
  );

  const handleSubmit = async () => {
    if (selectedItems.length === 0) {
      toast.error("Please select at least one item.");
      return;
    }

    // Filter selected data from accordionData
    const selectedDetails = accordionData.filter((row) =>
      selectedItems.some((selected) => selected.ProjectInvoiceDetailID === row.ProjectInvoiceDetailID && selected.LineNo === row.LineNo)
    );
    const rowErrors = [];

    selectedDetails.forEach((item, idx) => {
      const rowNumber = idx + 1;
      const errors = [];

      // Validate InvoiceNo
      if (!item.InvoiceNo) {
        errors.push("Invoice No Required");
      }

      // Validate ExchangeRate
      if (item.ExchangeRate === undefined || item.ExchangeRate === null || item.ExchangeRate === "") {
        errors.push("Exchange Rate is required");
      } else if (isNaN(item.ExchangeRate) || Number(item.ExchangeRate) < 0) {
        errors.push("Exchange Rate must be a positive number");
      }


      if (errors.length > 0) {
        rowErrors.push(`Row ${rowNumber}: ${errors.join(", ")}`);
      }
    });

    if (rowErrors.length > 0) {
      rowErrors.forEach((error) => toast.error(error));
      return;
    }

    // Build payload
    const payloads = selectedDetails.map((item) => ({
      IsConfirmed: 1,
      BasicAmount: item.BasicAmount,
      AdjustmentAmount: item.AdjustmentAmount,
      InvoiceBasedOn_236: item.InvoiceBasedOn_236,
      LineNo: item.LineNo,
      ClientID: item.ClientID,
      SoPoBalance:item?.SoPoBalance,
      ProjectID: item.ProjectID,
      EmployeeID: item.EmployeeID,
      PresentDays: item.PresentDays,
      WorkingDays: item.WorkingDays,
      InvoicedAmount: Number(item.InvoicedAmount),
      InvoicedDays: item.InvoicedDays,
      ProjectInvoiceDetailID: item.ProjectInvoiceDetailID,
      ExchangeRate: Number(item.ExchangeRate),
      InvoiceNo: item.InvoiceNo,
      InvoiceDate: item.InvoiceDate,
      StartDate: item.StartDate,
      EndDate: item.EndDate,
      InvoiceFromDate: item.InvoiceFromDate,
      InvoiceToDate: item.InvoiceToDate,
      PaymentDueDate: item.PaymentDueDate,
      FollowUpDate: item.FollowUpDate,
      PaymentReceivedDate: item.PaymentReceivedDate,
      OverDueDays: item.OverDueDays || 0,
      TaxPercent: item.TaxPercent,
      PaymentTermDays: item.PaymentTermDays,
      OverDueAmount: item.OverDueAmount || 0,
      InvoiceCalculatedAmount: Number(item.InvoiceCalculatedAmount) || 0,
      Remarks: item.Remarks || "",
    }));
    setSubmitButton(true)
    try {
      const response = await PostServiceCaller(
        `${API_URL}projectmanagement/list/invoice-list/consulting-and-content-getData`,
        { lines: payloads },
        "post"
      );

      if (response?.status === 200) {
        setSubmitButton(false)

        toast.success("Invoice submitted successfully!");
        fetchApiData(filterData);
        setSelectedItems([]);
      } else {
        setSubmitButton(false)

        throw new Error("Failed to submit");
      }
    } catch (error) {
      setSubmitButton(false)

      console.error("Submit error:", error);
      toast.error("Failed to submit invoice");
    }
  };

  return (
    <div className="container-fluid" id="skill_section">
      <div className="" id="skill-table-area">
        <div className="row">
          <div className="col-md-2">
            <label style={customStyle.formLabel}>Client</label>
            <Select
              name="clientID"
              classNamePrefix="select-sm"
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "25px",
                  height: "35px",
                }),
           menuPortal: (base) => ({ ...base, zIndex: 9999 }), // 👈 dropdown z-index

              }}
                menuPortalTarget={document.body} // 👈 portal to body to avoid overflow issues
  menuPosition="fixed" // 👈 use fixed positioning
              value={clientOptions.find(
                (opt) => opt.value === filterData.clientID
              ) || null}
              options={[{ value: null, label: "Select" }, ...clientOptions]}
              onChange={(selectedOptions) =>
                handleFilterSelect(selectedOptions, "clientID")
              }
            />
          </div>
          <div className="col-md-2">
            <label style={customStyle.formLabel}>Project</label>
            <Select
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "25px",
                  height: "35px",
                }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }), // 👈 dropdown z-index

              }}
                menuPortalTarget={document.body} // 👈 portal to body to avoid overflow issues
  menuPosition="fixed" // 👈 use fixed positioning
              name="projectID"
              value={projectOptions.find(
                (opt) => opt.value === filterData.projectID
              ) || null}
              options={[{ value: null, label: "Select" }, ...projectOptions]}
              onChange={(selectedOptions) =>
                handleFilterSelect(selectedOptions, "projectID")
              }
            />
          </div>
          <div className="col-md-2">
            <label style={customStyle.formLabel}>Employee</label>
            <Select
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "25px",
                  height: "35px",
                }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // 👈 dropdown z-index

              }}
                menuPortalTarget={document.body} // 👈 portal to body to avoid overflow issues
  menuPosition="fixed" // 👈 use fixed positioning
              name="employeeID"
              value={employeeOptions.find(
                (opt) => opt.value === filterData.employeeID
              ) || null}
              options={[{ value: null, label: "Select" }, ...employeeOptions]}
              onChange={(selectedOptions) =>
                handleFilterSelect(selectedOptions, "employeeID")
              }
            />
          </div>
          <div className="col-md-6 mt-3 pt-1 text-end">
            <button className="custom-btn me-2" onClick={handleReset}>
              Reset
            </button>
            <button className="custom-btn me-2" onClick={handleFilter}>
              Get Data
            </button>


            <button
              className="custom-btn"
              onClick={handleSubmit}
              disabled={submitButton} // 🔒 disable when loading
            >
              {submitButton ? <FaSpinner className="sm-spinner" /> : "Submit"}
            </button>
          </div>
        </div>

        {isLoading ? (

          <div className="d-flex mt-5 flex-column align-items-center">
            <FaSpinner className="spinner mb-2" />
            <span>Loading</span>
          </div>

        ) : Object.keys(groupedData).length > 0 ?
          <div className="row mt-3 overflow-auto">
            <div className="table-responsive zoomable-div-InvoiceList " style={{ height: "500px", overflow: "scroll" }}>
              <Table bordered>
                <thead className="invoice-table-header" >
                  <tr style={{ color: "#fff" }}>
                    <th style={{ backgroundColor: "#525c69", color: "#fff" }}
                      colSpan={4}>
                      <div className="d-flex mt-2">
                        <p>
                          <span>&nbsp;</span>
                          {`${accordionData?.length || 0} Invoice Details`}
                        </p>
                        <p
                          style={{ ...customIndicator, background: "#bad893" }}
                        ></p>
                        <span>FixedBid</span>
                        <p
                          style={{ ...customIndicator, background: "#ffe4a4" }}
                        ></p>
                        <span>Const</span>
                        <p
                          style={{ ...customIndicator, background: "#DEB887" }}
                        ></p>
                        <span>FZE</span>
                      </div>
                    </th>
                    <th style={{ backgroundColor: "#525c69", color: "#fff" }}
                      colSpan={13}>Invoice Details</th>
                    <th style={{ backgroundColor: "#525c69", color: "#fff" }}
                    >Payment Details</th>
                    <th style={{ backgroundColor: "#525c69", color: "#fff" }}
                    ></th>
                  </tr>
                  <tr>
                    <th style={{ backgroundColor: "#525c69", color: "#fff" }}
                    >#</th>
                    <th style={{ backgroundColor: "#525c69", color: "#fff" }}
                    >Emp. Name</th>
                    <th style={{ width: "20px", backgroundColor: "#525c69", color: "#fff" }} >Present (Days)</th>
                    <th style={{ minWidth: "30px", backgroundColor: "#525c69", color: "#fff" }}>Nice Working Days</th>
                    <th style={{ minWidth: "50px", backgroundColor: "#525c69", color: "#fff" }}>Inv. Days</th>
                    <th style={{ minWidth: "90px", backgroundColor: "#525c69", color: "#fff" }}>Rate/Freq</th>
                    <th style={{ minWidth: "90px", backgroundColor: "#525c69", color: "#fff" }}>From Dt.</th>
                    <th style={{ minWidth: "90px", backgroundColor: "#525c69", color: "#fff" }}>To Dt.</th>
                    <th style={{ minWidth: "100px", backgroundColor: "#525c69", color: "#fff" }}>Basic Amt</th>
                    <th style={{ minWidth: "100px", backgroundColor: "#525c69", color: "#fff" }}>Adj. Amt.</th>
                    <th style={{ minWidth: "100px", backgroundColor: "#525c69", color: "#fff" }}>Proforma Amt.</th>
                    <th style={{ minWidth: "60px", backgroundColor: "#525c69", color: "#fff" }}>Tax %</th>
                    <th style={{ minWidth: "50px", backgroundColor: "#525c69", color: "#fff" }}>
                      Exc. Rate<span className="text-danger">*</span>
                    </th>
                    <th style={{ minWidth: "90px", backgroundColor: "#525c69", color: "#fff" }}>Invoice Amt.</th>
                    <th style={{ minWidth: "90px", backgroundColor: "#525c69", color: "#fff" }}>PO Balance</th>
                    <th style={{ minWidth: "90px", backgroundColor: "#525c69", color: "#fff" }}>Date</th>
                    <th style={{ minWidth: "120px", backgroundColor: "#525c69", color: "#fff" }}>
                      No.<span className="text-danger">*</span>
                    </th>
                    {/* <th style={{ minWidth: "60px" }}>Term Days</th> */}
                    <th style={{ minWidth: "90px", backgroundColor: "#525c69", color: "#fff" }}>Due Dt.</th>
                    {/* <th style={{ minWidth: "90px" }}>Follow-up Dt.</th> */}
                    {/* <th style={{ minWidth: "90px" }}>Recd. Dt.</th> */}
                    {/* <th style={{ minWidth: "70px" }}>Overdue</th> */}
                    <th style={{ minWidth: "90px", backgroundColor: "#525c69", color: "#fff" }}>Remarks</th>
                  </tr>
                </thead>

                <tbody>
                  {Object.entries(groupedData).map(
                    ([clientName, projects], clientIndex) => (
                      <React.Fragment key={clientIndex}>
                        <tr>
                          <td colSpan={23} style={{ padding: "0px" }}>
                            <div
                              className="flex-grow-1"
                              style={{
                                background: "#CDE6FF",
                                color: "#000",
                                padding: "8px",
                                fontWeight: "bold",
                              }}
                            >
                              {clientName}
                            </div>
                          </td>
                        </tr>
                        {Object.entries(projects).map(
                          ([projectName, items], projectIndex) => {
                            const tmpProjectInvoiceDetailNumber =
                              items[0]?.tmpProjectInvoiceDetailNumber || "";
                            const StartDate = items[0]?.StartDate
                              ? moment(items[0]?.StartDate).format("DD-MMM-YYYY")
                              : "";
                            const EndDate = items[0]?.EndDate
                              ? moment(items[0]?.EndDate).format("DD-MMM-YYYY")
                              : "";

                            return (
                              <React.Fragment key={projectIndex}>
                                <tr>
                                  <td
                                    colSpan={23}
                                    style={{
                                      fontWeight: "bold",
                                      padding: "0px",
                                    }}
                                  >
                                    <div
                                      className="flex-grow-1"
                                      style={{
                                        background:
                                         projectallocationOption?.some(
                                              (o) =>
                                                [6706, 6708, 6709].includes(
                                                  o.value
                                                ) &&
                                                o.value ===
                                                items[0]
                                                  ?.ProjectAllocationType_160
                                            )
                                              ? "#DEB887"
                                              :   items[0]?.FixedBid === 1
                                            ? "#dbebc7"
                                            :projectallocationOption?.some(
                                                (o) =>
                                                  o.value ===
                                                  items[0]
                                                    ?.ProjectAllocationType_160 &&
                                                  o.value === 1138
                                              )
                                                ? "#c3d6eb"
                                                // "#ECECEC"
                                                : "#c3d6eb",
                                        color: "gray",
                                        padding: "8px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {`${projectName}: `}
                                      {tmpProjectInvoiceDetailNumber
                                        ? ` (SOW/PO/SO: ${tmpProjectInvoiceDetailNumber} ${StartDate} - ${EndDate})`
                                        : ""}
                                    </div>
                                  </td>
                                </tr>
                                {items.map((data, subIndex) => (
                                  <InvoiceRow
                                    key={`${clientIndex}-${projectIndex}-${subIndex}`}
                                    data={data}
                                    index={data.index}
                                    isSelected={selectedItems.some(
                                      (item) => item.index === data.index
                                    )}
                                    onCheckboxChange={handleCheckBoxChange}
                                    onFieldChange={handleFieldChange}
                                    onDateChange={handleDateChange}
                                    projectallocationOption={projectallocationOption}
                                  />
                                ))}
                              </React.Fragment>
                            );
                          }
                        )}
                      </React.Fragment>
                    )
                  )}
                </tbody>

              </Table>
            </div>
            <div className="d-flex justify-content-end">
              <Pagination
                itemsPerPage={itemsPerPage}
                totalItems={accordionData.length}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          </div> : apiStatus === 200 ? (
            <div className="d-flex mt-5 flex-column align-items-center">

              <h4>No data found</h4>

            </div>
          ) : null}
      </div>
    </div>
  );
};

export default InvoiceList;